import { MenuItemTypes } from "@/Enums/MenuItemTypes";

import ParticipantPageDto from '@/Models/ParticipantPageDto';

import { CaseService } from "@/Services/case-service";
import { ParticipantService } from "@/Services/participant-service";
import { PhaseService } from "@/Services/phase-service";
import { EligibilityService } from "../eligibility-service";

export const loadParticipantData = (pageType: string, id: number | null) => {
	return new Promise<ParticipantPageDto>((resolve, reject) => {
		if (pageType == undefined || pageType == "" || id == null || isNaN(id)) {
			// rather than rejecting this promise, we want it to silently resolve to an
			// empty object that will get coalesced on the front end. paths falling into
			// this branch are likely outside of the standard participant page structure,
			// and so no meaningful participant can be retrieved. if that assumption changes
			// this should be revisited
			// reject(`Unable to find ${pageType} ID.`);
			resolve(new ParticipantPageDto());		
		} else {
			switch (pageType) {
				case MenuItemTypes.Participant:
					ParticipantService.getParticipant(id)
						.then(result => resolve(ParticipantPageDto.getFromParticipant(result)))
						.catch(error => reject(error));
					break;
				case MenuItemTypes.Case:
					CaseService.getCase(id)
						.then(result => resolve(ParticipantPageDto.getFromCase(result)))
						.catch(error => reject(error));
					break;
				case MenuItemTypes.Phase:
					PhaseService.getPhase(id)
						.then(result => resolve(ParticipantPageDto.getFromPhase(result)))
						.catch(error => reject(error));
					break;
                case MenuItemTypes.Eligibility:
                    EligibilityService.get(id)
                        .then(result => resolve(ParticipantPageDto.getFromEligibility(result)))
                        .catch(error => reject(error));
                    break;
				default:
					resolve(new ParticipantPageDto());
			}
		}
	});
}

export const loadParticipantDataRequireParticipant = (pageType: string, id: number | null) => {
	return new Promise<ParticipantPageDto>((resolve, reject) => {
		loadParticipantData(pageType, id).then(data => {
			if (data.participant?.participantId == undefined) {
				reject("Unable to load participant");
			}
			else {
				resolve(data);
			}
		}).catch(error => reject(error));
	});
}

export const loadParticipantDataRequireCase = (pageType: string, id: number | null) => {
	return new Promise<ParticipantPageDto>((resolve, reject) => {
		loadParticipantData(pageType, id).then(data => {
			if (data.case?.caseId == undefined) {
				reject("Unable to load case");
			}
			else if (data.participant?.participantId == undefined) {
				reject("Unable to load participant");
			}
			else {
				resolve(data);
			}
		}).catch(error => reject(error));
	});
}

export const loadParticipantDataRequirePhase = (pageType: string, id: number | null) => {
	return new Promise<ParticipantPageDto>((resolve, reject) => {
		loadParticipantData(pageType, id).then(data => {
			if (data.phase?.phaseId == undefined) {
				reject("Unable to load phase");
			}
			else if (data.case?.caseId == undefined) {
				reject("Unable to load case");
			}
			else if (data.participant?.participantId == undefined) {
				reject("Unable to load participant");
			}
			else {
				resolve(data);
			}
		}).catch(error => reject(error));
	});
}
